import { useEffect, useState } from 'react';

const STORAGE_KEY = 'gugu-pwa-install-dismissed';

function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
}

function isInStandaloneMode() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

export default function InstallPrompt() {
  const [show, setShow] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [platform, setPlatform] = useState(null); // 'ios' | 'android'

  useEffect(() => {
    if (isInStandaloneMode()) return;
    if (localStorage.getItem(STORAGE_KEY)) return;

    if (isIOS()) {
      setPlatform('ios');
      setShow(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setPlatform('android');
      setShow(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  function handleDismiss() {
    localStorage.setItem(STORAGE_KEY, '1');
    setShow(false);
  }

  async function handleInstallAndroid() {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      localStorage.setItem(STORAGE_KEY, '1');
    }
    setShow(false);
    setDeferredPrompt(null);
  }

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: 'linear-gradient(135deg, #001e45 0%, #0147a0 100%)',
        color: '#fff',
        padding: '16px 20px',
        boxShadow: '0 -4px 24px rgba(0,0,0,0.35)',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '14px',
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* Ícone */}
      <img
        src="/logotipo_gugu.png"
        alt="Gugu Turismo"
        style={{ width: 48, height: 48, borderRadius: 10, flexShrink: 0, objectFit: 'contain', background: '#fff', padding: 4 }}
      />

      {/* Texto */}
      <div style={{ flex: 1 }}>
        <p style={{ margin: '0 0 4px', fontWeight: 700, fontSize: 15 }}>
          Instale o Gugu Turismo
        </p>

        {platform === 'ios' ? (
          <p style={{ margin: 0, fontSize: 13, color: '#c8d8f0', lineHeight: 1.5 }}>
            Toque em{' '}
            <span style={{ fontWeight: 700, color: '#f9c900' }}>
              Compartilhar{' '}
              <svg
                style={{ display: 'inline', verticalAlign: 'middle', marginBottom: 2 }}
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#f9c900"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                <polyline points="16 6 12 2 8 6" />
                <line x1="12" y1="2" x2="12" y2="15" />
              </svg>
            </span>{' '}
            e depois em{' '}
            <span style={{ fontWeight: 700, color: '#f9c900' }}>"Adicionar à Tela Inicial"</span>{' '}
            para acessar rapidamente pelo celular.
          </p>
        ) : (
          <p style={{ margin: 0, fontSize: 13, color: '#c8d8f0', lineHeight: 1.5 }}>
            Adicione o app na tela inicial do seu celular para acesso rápido, sem precisar do navegador.
          </p>
        )}
      </div>

      {/* Botões */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, flexShrink: 0 }}>
        {platform === 'android' && (
          <button
            onClick={handleInstallAndroid}
            style={{
              background: '#f9c900',
              color: '#001e45',
              border: 'none',
              borderRadius: 8,
              padding: '8px 16px',
              fontWeight: 700,
              fontSize: 13,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
          >
            Instalar
          </button>
        )}
        <button
          onClick={handleDismiss}
          style={{
            background: 'transparent',
            color: '#8aadcc',
            border: '1px solid #2a4a70',
            borderRadius: 8,
            padding: '8px 16px',
            fontSize: 13,
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          Agora não
        </button>
      </div>
    </div>
  );
}
